import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { I18N_DEFAULT_LOCALE } from '@/common/constants/i18n.constants';
import ruPluralization from '@/common/utils/ruPluralization';

Vue.use(VueI18n);

const i18n = new VueI18n({
  // NOTE (mpetrov): locale must not be chosen on plugin initialization
  locale: '',
  fallbackLocale: I18N_DEFAULT_LOCALE,
  // Use of single space is necessary to prevent artifacts before loading files with locales.
  // It is not possible to use an empty string because it is defined as a false value.
  missing: process.env.NODE_ENV === 'production' ? () => ' ' : undefined,
  silentTranslationWarn: true,
  messages: {
    // NOTE (mpetrov): do not load default locale during build
  },
  pluralizationRules: {
    ru: ruPluralization
  }
});

export { i18n };
export default i18n;
